const metadataKeys = {
  integrationKey: 'integration',
  cdIntegrationValue: 'concreteDirect',
  cdOrderKey: 'orderId',
}

export default metadataKeys
